module.exports = __webpack_public_path__ + "img/kcjsgm-banner.1cafbe58.png";